module.exports = __webpack_public_path__ + "static/media/FelipeFreitas.0573e4ff.jpg";